module Tapas.Bindings {
    export class ClickToggleClass {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var value = valueAccessor();

            ko.utils.registerEventHandler(element, "click", function () {
                $(element).toggleClass(valueAccessor);
            });
        }
    }
    ko.bindingHandlers['clickToggleClass'] = new ClickToggleClass();
} 
